// Import Core
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useLocation } from "@reach/router";
// Import Libraries
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby-link";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation as swiperNavigation,
  Pagination as swiperPagination,
} from "swiper/modules";
// Import Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// Import Components
import Separator from "../../ui/Separator";
import TextButton from "../../ui/buttons/TextButton";
import IconList from "../../ui/IconList";
import Stars from "../../ui/Stars";
import RelatedTripsLocations from "../RelatedTripsLocations";
import FilterDropdown from "../../ui/FilterDropdown";
import FilterPagination from "../../ui/FilterPagination";
// Import Utils
import { usePlaceholderImage } from "../../../utils/useRandomPlaceholderImage";
import { renderReactIcon } from "../../../utils/renderReactIcons";
import { getSlug } from "../../../utils/getSlug";
import { getShortDate } from "../../../utils/datetime/getShortDate";
import { getAuthor } from "../../../utils/getAuthor";
import { getCardTagline } from "../../../utils/getCardTagline";
import { navigate } from "gatsby";
import SortByDropdown from "../../ui/SortByDropdown";
import Button from "../../ui/buttons/Button";
import dayjs from "dayjs";
var advancedFormat = require("dayjs/plugin/advancedFormat");
dayjs.extend(advancedFormat);

const ArchivePageStyling = styled.section`
  display: flex;
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 80px 0;
  /* padding: 80px 64px; */
  flex-direction: column;
  align-items: center;
  gap: 64px;
  background-color: var(--white);
  @media (max-width: 1570px) {
    padding: 80px 64px;
  }

  @media (max-width: 992px) {
    padding: 40px 20px;
    gap: 32px;
  }
  .section-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    width: 100%;
  }
  .search-wrapper {
    display: flex;
    width: 100%;
    padding: 40px 0 80px;
    align-items: flex-start;
    gap: 64px;
    position: relative;
    @media (max-width: 1200px) {
    }
    @media (max-width: 992px) {
      flex-direction: column;
      padding: 24px 0 0;
      gap: 20px;
    }
    .sidebar {
      display: flex;
      max-width: 290px;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      min-width: 288px;
      /* position: sticky;
			top: 200px; */

      @media (max-width: 992px) {
        display: none;
        max-width: unset;
        width: 100%;
        position: unset;
        gap: 32px;
      }
      /* TODO:  SHOW ONCE FILTERS ARE DONE */
      /* display: none; */
      .sidebar-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .sidebar-heading-title {
          text-transform: uppercase;
          font-family: var(--font-family-heading);
        }
        .clear-all-btn {
          color: var(--neutral-25);
          text-transform: uppercase;
          font-family: var(--font-family-heading);
        }
      }
      .accordion {
        width: 100%;
      }
    }
    .mobile-filters {
      display: none;
      @media (max-width: 992px) {
        display: block;
        width: 100%;
        & button {
          width: 100%;
        }
      }
    }
    .mobile-filers-wrapper {
      z-index: 999;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--white);
      padding: 16px 0;
      .heading {
        font-size: 24px;
        line-height: 28px;
        color: var(--black);
        margin-bottom: 24px;
        padding: 0 16px;
      }
      p.small {
        padding: 16px;
        padding-top: 0;
      }
    }
    .close-filters {
      padding: 0 16px;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
    }
    .dropdowns-wrapper {
      max-height: 75dvh;
      overflow-y: scroll;
      padding: 0 16px;
    }
    .results-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      flex: 1 0 0;
      .result-wrapper-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        @media (max-width: 992px) {
          flex-direction: column-reverse;
          gap: 16px;
        }
      }
      .current-search-tags {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 10px;
      }
      .tag-wrapper {
        padding: 2px 4px 2px 8px;
        background-color: var(--grey-10);
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        font-size: 16px;
        line-height: 24px;
      }
      .reset-tag {
        display: flex;
        cursor: pointer;
        padding: 4px;
      }
      .results {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        width: 100%;
        .card-wrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 36px;
          align-self: stretch;
          .card {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            width: 100%;
            .card-title {
              display: flex;
              padding-right: 16px;
              justify-content: flex-end;
              align-items: flex-end;
              gap: 10px;
              align-self: stretch;
              @media (max-width: 992px) {
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
              }
              .left {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 16px;
                flex: 1 0 0;
                .tagline {
                }
              }
              .right {
                @media (max-width: 768px) {
                  width: 100%;
                }
                .price {
                  color: var(--blue);
                }
                .ratings {
                  display: flex;
                  gap: 16px;
                  .star-rating {
                    display: flex;
                    justify-content: flex-end;
                    .star {
                      width: 18.5px;
                      height: 17.6px;
                    }
                  }
                  .hotel-type {
                    text-transform: capitalize;
                  }
                }
                .review-info {
                  display: flex;
                  gap: 8px;
                  flex-direction: column;
                  align-items: flex-end;
                  flex-wrap: wrap;
                  @media (max-width: 992px) {
                    align-items: center;
                    justify-content: space-between;
                    flex-direction: row-reverse;
                  }
                  .published-date {
                    color: var(--neutral-75);
                  }
                  .author {
                    color: var(--neutral-75);
                    span {
                      color: var(--red);
                    }
                  }
                }
                .related {
                  margin-top: 16px;
                }
              }
            }
            .image-text-content {
              width: inherit;
              display: flex;
              padding-right: 16px;
              align-items: flex-start;
              gap: 32px;
              @media (max-width: 1200px) {
                flex-wrap: wrap;
                padding-right: 0px;
              }
              @media (max-width: 992px) {
                flex-direction: column;

                gap: 24px;
              }
              .img-slider-wrapper {
                width: 280px;
                @media (max-width: 992px) {
                  width: 100%;
                }
                .swiper {
                  .swiper-button-prev,
                  .swiper-button-next {
                    background-color: var(--red);
                    width: 32px;
                    height: 32px;
                    padding: 9px 0px;
                    &:after {
                      color: var(--white);
                      font-size: 12px;
                      font-style: normal;
                      font-weight: 900;
                      line-height: 150%;
                    }

                    &:hover {
                      background-color: var(--red-110);
                    }
                    &.swiper-button-disabled {
                      display: none;
                    }
                  }
                  .swiper-pagination {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                    padding: 8px 16px;
                    margin: 0;
                    z-index: 1;
                    .swiper-pagination-bullet {
                      width: 8px;
                      height: 8px;
                      border-radius: 0;
                      opacity: 1;
                      background-color: var(--neutral-50);
                      &.swiper-pagination-bullet-active {
                        background-color: var(--white);
                      }
                    }
                  }
                }
              }

              .gatsby-image-wrapper-constrained,
              .placeholder-img {
                width: 280px;
                height: 280px;
                @media (max-width: 992px) {
                  /* width: 50%; */
                  width: 100%;
                }
              }
              img {
                display: block;
                /* width: 280px;
                height: 280px; */
                object-fit: cover;
              }
              .content {
                width: inherit;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1 0 0;
                padding-top: 16px;
                gap: 16px;
                .special-offer {
                  .offer {
                    color: var(--blue);
                    .badge {
                      padding: 4px 8px;
                      margin: 0 8px 0 -5px;
                      border-radius: 4px;
                      background: var(--blue-75);
                      color: var(--white);
                    }
                  }
                }
              }
              .includes {
                max-width: 175px;
                display: flex;
                padding-bottom: 16px;
                flex-direction: column;
                align-items: flex-start;
                padding-left: 32px;
                border-left: 1px solid var(--neutral-10);
                /* gap: 8px; */
                /* align-self: stretch; */
                flex-shrink: 1;
                @media (max-width: 1200px) {
                  flex-direction: row;
                  border-left: none;
                  padding-left: 0;
                  max-width: 100%;
                }
                .included-items {
                  display: flex;
                  gap: 16px;
                  align-items: flex-end;
                  position: relative;
                  .icon-list {
                    flex-direction: column;
                    align-items: flex-start;
                    @media (max-width: 1200px) {
                      flex-direction: row;
                    }
                    .icon-list-item {
                      .icon-name {
                        flex: 1 0 0;
                      }
                    }
                    .popover {
                      .popover-wrapper {
                        .popover.popover-top {
                          top: calc(24px * -3.5);
                        }
                      }
                    }
                    .popover-children {
                      .includes-popover {
                        display: flex;
                        height: 24px;
                        padding: 8px;
                        justify-content: center;
                        align-items: center;
                        gap: 8px;
                        border-radius: 4px;
                        background-color: var(--red-10);
                        color: var(--red);
                        position: relative;
                        cursor: pointer;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .card-price {
      font-size: 24px;
      line-height: 28px;
      font-weight: 700;
      margin-top: 16px;
    }
    .tags-wrapper {
      display: flex;
      width: 100%;
      justify-content: space-between;
      .single-tag-wrapper {
        color: var(--orange-120);
      }
    }
  }
  .red-bg {
    &.card-wrapper {
      .card {
        .card-title {
          .left {
            .copies-wrapper {
              display: flex;
              gap: 16px;
            }
            .tagline,
            .highly-recommended {
              z-index: 1;
              padding: 4px 8px;
              border-radius: 4px;
              font-weight: 700;
              font-family: var(--font-family-base-bold);
              font-size: 0.778rem; //14px
            }
            .tagline {
              display: flex;
              align-items: flex-start;
              gap: 8px;
              background: var(--red-light);
              color: var(--red);
            }
            .highly-recommended {
              background: var(--blue-10);
              color: var(--blue);
            }
          }
        }
      }
    }
  }
  .orange-bg {
    .tagline {
      display: flex;
      padding: 4px 8px;
      align-items: flex-start;
      gap: 8px;
      border-radius: 4px;
      background: var(--orange-10);
      color: var(--orange-120);
      font-weight: 700;
      font-family: var(--font-family-base-bold);
      font-size: 0.778rem; //14px
      width: fit-content;
    }
    &.card-wrapper {
      .card {
        .card-title {
          .left {
            .tagline {
              display: flex;
              padding: 4px 8px;
              align-items: flex-start;
              gap: 8px;
              border-radius: 4px;
              background: var(--orange-10);
              color: var(--orange-120);
              font-weight: 700;
              font-family: var(--font-family-base-bold);
              font-size: 0.778rem; //14px
            }
          }
        }
        .image-text-content {
          .includes {
            .included-items {
              .icon-list-item {
                .list-icon {
                  background-color: var(--orange-10);
                  svg {
                    color: var(--orange-110);
                  }
                }
              }
              .popover-children {
                .includes-popover {
                  background-color: var(--orange-10);
                  color: var(--orange);
                }
              }
            }
          }
        }
      }
    }
    .special-offer {
      color: var(--blue-75);
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
    }
    .month-label {
      padding: 7px;
      background-color: var(--orange-10);
      color: var(--orange-120);
    }
  }
`;

const TourCard = ({ card, index, page, filters }) => {
  const cardRef = useRef(null);

  // Save the clicked card position
  const handleCardClick = () => {
    if (cardRef.current) {
      const { offsetTop } = cardRef.current;
      sessionStorage.setItem("scrollPosition", offsetTop);
    }
  };

  useEffect(() => {
    // Scroll to the saved position if it exists
    const savedPosition = sessionStorage.getItem("scrollPosition");
    if (savedPosition) {
      setTimeout(() => {
        window.scrollTo({
          top: parseInt(savedPosition, 10),
          behavior: "smooth",
        });
        sessionStorage.removeItem("scrollPosition");
      }, 100);
    }
  }, []);

  const getMinDate = (el) => {
    let datesArr = [];
    el.darwinDepartureDates.map((date) => {
      if (
        (date.departurestatus === "On Sale" ||
          date.departurestatus === "On Request") &&
        new Date(date.landonlydeparturedate).getTime() > new Date().getTime()
      ) {
        datesArr.push(date);
      }
    });
    if (datesArr.length > 0) {
      let arr2 = [
        ...datesArr.map((date) => new Date(date.landonlydeparturedate)),
      ];

      // Checking if there is any selectedDeparture dates
      if (
        filters.includedDepartureMonths &&
        filters.includedDepartureMonths.length > 0
      ) {
        // Formatting selected date from "December 2025" to "2025-12"
        let formattedDepartureDate = filters.includedDepartureMonths.map(
          (dateStr) =>
            new Date(dateStr).getFullYear() +
            "-" +
            (new Date(dateStr).getMonth() + 1).toString().padStart(2, "0")
        );

        // Finding the date that matches the selectedDeparture dates
        const minDate = datesArr.find((el) => {
          let elDate = el.landonlydeparturedate.substring(0, 7); // Extracting "YYYY-MM"
          return formattedDepartureDate.includes(elDate); // Checking if it matches
        });

        // Return minDate if found, if undefined return fallback (first valid date)
        return minDate || datesArr[0];
      } else {
        let minDate = datesArr.find(
          (el) =>
            new Date(el.landonlydeparturedate).getTime() === Math.min(...arr2)
        );
        return minDate;
      }
    }
  };
  const getOfferPriceAndDuration = (el) => {
    if (el.darwinDepartureDates?.length > 0) {
      let minDate = getMinDate(el);
      // console.log("minDate", minDate);
      const priceWithoutSingleSupplement = (
        minDate?.landonlyadultprice - minDate?.singlesupplement
      ).toString();
      if (minDate !== undefined && minDate !== null) {
        return `${minDate.landonlyduration} nights from £${
          priceWithoutSingleSupplement.toString().length > 3
            ? priceWithoutSingleSupplement.slice(0, 1) +
              "," +
              priceWithoutSingleSupplement.slice(
                1,
                priceWithoutSingleSupplement.length
              )
            : priceWithoutSingleSupplement
        }pp`;
      }
    }
  };
  // function for blue text on the card
  const getOfferForSearchResultCard = (el) => {
    let minDate = getMinDate(el);

    if (minDate !== undefined && minDate !== null) {
      let MONTHS = {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December",
      };
      let month =
        MONTHS[new Date(Date.parse(minDate.landonlyreturndate)).getMonth() + 1];

      return `${new Date(
        Date.parse(minDate.landonlydeparturedate)
      ).getDate()} - ${new Date(
        Date.parse(minDate.landonlyreturndate)
      ).getDate()} ${month} ${new Date(
        Date.parse(minDate.landonlyreturndate)
      ).getFullYear()}: ${minDate.landonlyduration} nights from £${
        minDate.landonlyadultprice
        // minDate.singlesupplement !== null ? minDate.singlesupplement : minDate.landonlyadultprice
      } per person`;
    }
  };

  const getDepartureMonths = (el) => {
    let futureDates = el.darwinDepartureDates.filter(
      (date) =>
        (date.departurestatus === "On Request" ||
          date.departurestatus === "On Sale") &&
        dayjs(date.landonlydeparturedate).isAfter(dayjs())
    );
    let arr = [];
    let monthsArr = futureDates.map((date) => {
      if (!arr.includes(dayjs(date.landonlydeparturedate).format("MMM")))
        arr.push(dayjs(date.landonlydeparturedate).format("MMM"));
    });

    let months = arr.map((date2, index) => {
      return (
        <div key={`ml-${index}`} className="month-label">
          {date2}
        </div>
      );
    });

    return months;
  };

  const getTourDate = (el) => {
    let minDate = getMinDate(el);
    if (minDate !== undefined && minDate !== null) {
      return dayjs(minDate?.landonlydeparturedate).format("Do MMMM YYYY");
    }
  };
  const { randomPlaceholderImage } = usePlaceholderImage();

  let tags = [];
  if (card.themeTags !== null && card.themeTags !== undefined) {
    if (card.themeTags.themeTags !== null && card.themeTags !== undefined) {
      if (card.themeTags.themeTags.tag.length > 0) {
        card.themeTags.themeTags.tag.map((tag) => {
          tags.push(tag.label);
        });
      }
    }
  }
  if (tags.length > 0) tags.flat();

  // Adding this as will be making all Archive pages use same component
  const className = `${
    card._type === "culturalTour"
      ? " orange-bg"
      : card._type === "tailorMadeHoliday" ||
        card._type === "opera" ||
        card._type === "hotelBreak" ||
        card._type === "railJourney"
      ? " red-bg"
      : ""
  }`;

  // Some cards have one location, some have an array so we either set 'location' or 'locations'
  const location =
    card.city && card.country
      ? `${card.city.name}, ${card.country.name}`
      : card.city
      ? card.city.name
      : card.country
      ? card.country.name
      : null;

  const locations =
    card.includedCities && card.includedCities.length > 0
      ? card.includedCities.map((item) => item.name).join(", ")
      : null;

  const author = card._type === "review" ? getAuthor(card) : null;

  // TODO: THIS CAN BE REUSABLE COMPONENT?
  let includesIconList;
  if (card._type !== "hotelBreak") {
    includesIconList =
      card.includes && card.includes.length > 0
        ? card.includes.map((item) => {
            const Icon =
              item.icon !== null && item.icon !== undefined && item.icon !== ""
                ? renderReactIcon(item.icon.name)
                : null;
            return {
              icon: Icon,
              title: item.name,
            };
          })
        : null;
  } else {
    if (
      card.country.countryIncludes &&
      card.country.countryIncludes.length > 0
    ) {
      includesIconList = card.country.countryIncludes.map((item) => {
        const Icon =
          item.icon !== null && item.icon !== undefined && item.icon !== ""
            ? renderReactIcon(item.icon.name)
            : null;
        return {
          icon: Icon,
          title: item.name,
        };
      });
    } else if (card.city.cityIncludes && card.city.cityIncludes.length > 0) {
      includesIconList = card.city.cityIncludes.map((item) => {
        const Icon =
          item.icon !== null && item.icon !== undefined && item.icon !== ""
            ? renderReactIcon(item.icon.name)
            : null;
        return {
          icon: Icon,
          title: item.name,
        };
      });
    }
  }

  const iconsToShow = includesIconList ? includesIconList.slice(0, 4) : null;
  const popoverIcons =
    includesIconList && includesIconList.length > 4
      ? includesIconList.slice(4)
      : [];
  return (
    <div
      ref={cardRef}
      className={`card-wrapper${className}`}
      key={`${card._id}-${index}`}
    >
      <div className="card">
        <div className="card-title">
          {page.cptType === "tourCalendar" && (
            <div style={{ minWidth: "280px" }}>
              <p className="tagline">{getCardTagline(card._type)}</p>
              <p className="card-price">{getTourDate(card)}</p>
            </div>
          )}

          <div className="left">
            {page.cptType !== "tourCalendar" && (
              <div className="copies-wrapper">
                <p className="tagline">{getCardTagline(card._type)}</p>
                {card.highlyRecommended && (
                  <p className="highly-recommended">Highly Recommended</p>
                )}
              </div>
            )}
            <Link to={getSlug(card)} onClick={handleCardClick}>
              <h3 className="alt">{card.title}</h3>
            </Link>
          </div>
          <div className="right">
            {card.darwinDepartureDates &&
              card.darwinDepartureDates.length > 0 && (
                <p className="price medium bold">
                  {getOfferPriceAndDuration(card)}
                </p>
              )}

            {card._type === "review" && (
              <div className="review-info">
                {card.publishedDate && (
                  <p className="published-date medium">
                    {getShortDate(card.publishedDate)}
                  </p>
                )}
                {author && author.link && (
                  <p className="author">
                    by{" "}
                    <span>
                      <Link to={author.link}>{author.name}</Link>
                    </span>
                  </p>
                )}
              </div>
            )}
            {(card.starRating || card.hotelType) && (
              <div className="ratings">
                {card.starRating && (
                  <div className="star-rating">
                    <Stars starRating={card.starRating} />
                  </div>
                )}
                {card.hotelType && card.hotelType !== "none" && (
                  <p className="hotel-type bold italic red">{card.hotelType}</p>
                )}
              </div>
            )}
          </div>
        </div>
        <Separator color="grey-thin" />
        <div className="image-text-content">
          {card.thumbnail && card.thumbnail.asset ? (
            !!card.images ? (
              <div className="img-slider-wrapper">
                <Swiper
                  slidesPerView={"auto"}
                  // spaceBetween={36}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={true}
                  modules={[swiperPagination, swiperNavigation]}
                  className="card-carousel-swiper"
                >
                  {[...card.images]
                    .slice(0, 10) // limit the images to 10 otherwise pagination design is broken
                    .map((image, index) => (
                      <SwiperSlide key={`im-sl-${card.title}-${index}`}>
                        <Link to={getSlug(card)} onClick={handleCardClick}>
                          <GatsbyImage
                            image={getImage(image.asset)}
                            alt={card.title}
                            className="accordion-title-img"
                          />
                        </Link>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            ) : (
              <Link to={getSlug(card)} onClick={handleCardClick}>
                <GatsbyImage
                  image={getImage(card.thumbnail.asset)}
                  alt={card.title}
                  className="accordion-title-img"
                />
              </Link>
            )
          ) : (
            <Link to={getSlug(card)} onClick={handleCardClick}>
              <img
                src={randomPlaceholderImage}
                alt={card.title}
                className="placeholder-img"
              />
            </Link>
          )}
          <div className="content">
            {location ||
              (locations && (
                <p className="location medium bold">{location || locations}</p>
              ))}
            <p className="medium-excerpt">{card.excerpt}</p>
            {card.specialOffer && (
              <div className="special-offer">
                <p className="offer">
                  <span className="badge small bold">Special Offer</span>
                  {card.specialOffer}
                </p>
              </div>
            )}
            <Link
              to={getSlug(card)}
              className="read-more-btn"
              onClick={handleCardClick}
            >
              <TextButton
                size="md"
                className=""
                value={"Read More"}
                clickHandler={false}
                isDisabled={false}
              />
            </Link>
            {card._type === "review" && (
              <RelatedTripsLocations
                relatedTrip={card.relatedTrip}
                relatedLocations={card.relatedLocations}
              />
            )}
            {card._type === "culturalTour" ? (
              <div className="tags-wrapper">
                <div className="single-tag-wrapper">
                  {tags.length > 0 &&
                    tags
                      .map((tag, index) => {
                        return tag;
                      })
                      .join(", ")}
                </div>

                {card.darwinDepartureDates &&
                  card.darwinDepartureDates.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                      }}
                    >
                      {getDepartureMonths(card)}
                    </div>
                  )}
              </div>
            ) : (
              card.darwinDepartureDates &&
              card.darwinDepartureDates.length > 0 && (
                <p className="special-offer">
                  {getOfferForSearchResultCard(card)}
                </p>
              )
            )}
          </div>
          <div className="includes">
            {iconsToShow && iconsToShow.length > 0 && (
              <div className="included-items">
                <IconList
                  iconListItems={iconsToShow}
                  iconLayout="minimal"
                  addPopover={true}
                  popoverListItems={popoverIcons}
                  id={`${card._id}-${index}`}
                  addText={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <Separator color="red" />
    </div>
  );
};

const Tag = ({ tag, index, removeTag }) => {
  const capitalizeWords = (input) => {
    return input.toLowerCase().replace(/(?:^|\s)\S/g, (a) => {
      return a.toUpperCase();
    });
  };
  let content = capitalizeWords(tag.label);
  if (tag.type === "Star Rating") {
    content = `${capitalizeWords(tag.label)}-star`;
  }
  return (
    <div className="tag-wrapper" key={index}>
      {content}
      <div className="reset-tag" onClick={() => removeTag(tag)}>
        <svg
          width="20"
          height="24"
          viewBox="0 0 20 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.7812 8.28125L11.0312 12.0312L14.75 15.75C15.0625 16.0312 15.0625 16.5 14.75 16.7812C14.4688 17.0938 14 17.0938 13.7188 16.7812L9.96875 13.0625L6.25 16.7812C5.96875 17.0938 5.5 17.0938 5.21875 16.7812C4.90625 16.5 4.90625 16.0312 5.21875 15.7188L8.9375 12L5.21875 8.28125C4.90625 8 4.90625 7.53125 5.21875 7.21875C5.5 6.9375 5.96875 6.9375 6.28125 7.21875L10 10.9688L13.7188 7.25C14 6.9375 14.4688 6.9375 14.7812 7.25C15.0625 7.53125 15.0625 8 14.7812 8.28125Z"
            fill="#333333"
          />
        </svg>
      </div>
    </div>
  );
};

const CulturalTourContent = ({
  page,
  results,
  filterableData,
  locattion,
  sortType = null,
  artists,
  tourLeaders,
}) => {
  // States
  const location = useLocation();
  const initialState = {
    includedCountries: [],
    includedRegions: [],
    includedDestinations: [],
    includedDepartureMonths: [],
    includedThemes: [],
    includedTourLeaders: [],
    includedArtists: [],
  };
  const [filters, setFilters] = useState(initialState);
  const [tags, setTags] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [culturalTourArchivePageResults, setCulturalTourArchivePageResults] =
    useState([]);

  const hasMounted = useRef(false);

  // Tags are being pulled of chosen filters
  useEffect(() => {
    let tagsArr = [];
    Object.entries(filters).forEach(([key, values]) => {
      if (values.length > 0) {
        values.forEach((value) => {
          tagsArr.push({ category: key, label: value });
        });
      }
    });
    setTags(tagsArr);
  }, [filters]);

  // Getting selected filter from params
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const includedCountries = params.get("countries")?.split(",") || [];
    const includedRegions = params.get("regions")?.split(",") || [];
    const includedDestinations = params.get("cities")?.split(",") || [];
    const includedDepartureMonths =
      params.get("departureMonths")?.split(",") || [];
    const includedTourLeaders = params.get("tourLeaders")?.split(",") || [];
    const includedArtists = params.get("artists")?.split(",") || [];
    const includedThemes = params.get("themes")?.split(",") || [];

    const page = Math.max(parseInt(params.get("page") || "1", 10) - 1, 0);

    setFilters({
      includedCountries,
      includedRegions,
      includedDestinations,
      includedDepartureMonths,
      includedThemes,
      includedTourLeaders,
      includedArtists,
    });
    setCurrentPage(page);
    hasMounted.current = true;
  }, []);

  // Setting selected filter from params
  useEffect(() => {
    if (!hasMounted.current) return;

    const params = new URLSearchParams();

    if (filters.includedCountries.length > 0) {
      params.set("countries", filters.includedCountries.join(","));
    }
    if (filters.includedRegions.length > 0) {
      params.set("regions", filters.includedRegions.join(","));
    }
    if (filters.includedDestinations.length > 0) {
      params.set("cities", filters.includedDestinations.join(","));
    }
    if (filters.includedTourLeaders.length > 0) {
      params.set("tourLeaders", filters.includedTourLeaders.join(","));
    }
    if (filters.includedArtists.length > 0) {
      params.set("artists", filters.includedArtists.join(","));
    }
    if (filters.includedDepartureMonths.length > 0) {
      params.set("departureMonths", filters.includedDepartureMonths.join(","));
    }
    if (filters.includedThemes.length > 0) {
      params.set("themes", filters.includedThemes.join(","));
    }

    params.set("page", currentPage + 1);
    navigate(`?${params.toString()}`, { replace: true });
  }, [filters, currentPage]);

  // Checkbox handle and updating the filter
  const handleCheckboxChange = (filterType, value) => {
    setFilters((prevFilters) => {
      const updatedFilter = prevFilters[filterType].includes(
        value.toLowerCase()
      )
        ? prevFilters[filterType].filter((item) => item !== value.toLowerCase())
        : [...prevFilters[filterType], value.toLowerCase()];

      return { ...prevFilters, [filterType]: updatedFilter };
    });
    // Getting to the first page on checkbox change
    setCurrentPage(0);
  };

  // Handling sorting results cards
  const sortByHandler = (value) => {
    setSortBy(value);
  };

  // Resetting the filter
  const resetAllFilters = () => {
    setFilters(initialState);
    setCurrentPage(0);
    window.history.pushState({}, "", `${location.pathname}`);
  };

  // Removing tag and updating filter
  const removeTag = (tagToRemove) => {
    const { category, label } = tagToRemove;

    setFilters((prevFilters) => ({
      ...prevFilters,
      [category]: prevFilters[category].filter((item) => item !== label),
    }));

    // Getting to the first page on each tag remove
    setCurrentPage(0);
  };

  // Show available departure months and format Departure Months
  const formatDates = (tour) => {
    if (!tour.darwinDepartureDates || tour.darwinDepartureDates.length === 0) {
      return [];
    }

    const datesArr = tour.darwinDepartureDates.filter(
      (date) =>
        ["On Request", "Available", "On Sale"].includes(date.departurestatus) &&
        dayjs(date.landonlydeparturedate).isAfter(dayjs())
    );

    return datesArr.map(
      (date) =>
        `${dayjs(date.landonlydeparturedate).format("MMMM")} ${dayjs(
          date.landonlydeparturedate
        ).format("YYYY")}`
    );
  };

  // Get result counts on each filter category option
  const getCounts = (array) => {
    const counts = array.reduce((acc, tour) => {
      acc[tour] = (acc[tour] || 0) + 1;
      return acc;
    }, {});

    return { counts };
  };

  // Utility to filter results based on selected categories
  const matchingResults = (filterType, typeName, tour) => {
    // Filter out the tour leaders whose tours array is empty
    const validTourLeaders = tourLeaders.filter(
      (leader) => leader.tours && leader.tours.length > 0
    );
    // Filter out the artists whose tours array is empty
    const validArtists = artists.filter(
      (artist) => artist.tours && artist.tours.length > 0
    );

    if (typeName == "includedDepartureMonths") {
      return (
        filterType.length === 0 ||
        filterType.some(
          (date) =>
            formatDates(tour) &&
            formatDates(tour)
              .map((date) => date.toLowerCase())
              .filter((date) => date)
              .sort(
                (a, b) =>
                  dayjs(a, "MMMM YYYY").toDate() -
                  dayjs(b, "MMMM YYYY").toDate()
              )
              .includes(date)
        )
      );
    } else if (typeName == "includedTourLeaders") {
      return (
        filterType.length === 0 ||
        validTourLeaders.some(
          (leader) =>
            filterType.includes(leader.title.toLowerCase()) &&
            leader.tours.some((leaderTour) => leaderTour._id === tour._id)
        )
      );
    } else if (typeName === "includedArtists") {
      return (
        filterType.length === 0 ||
        validArtists.some(
          (artist) =>
            filterType.includes(artist.title.toLowerCase()) &&
            artist.tours.some((artistTour) => artistTour._id === tour._id)
        )
      );
    } else if (typeName === "includedThemes") {
      return (
        filterType.length === 0 ||
        filterType.some((themes) =>
          tour.themeTags?.themeTags?.tag
            .map((t) => t.label.toLowerCase())
            .includes(themes)
        )
      );
    } else {
      return (
        filterType.length === 0 ||
        filterType.some((item) =>
          tour[typeName].map((c) => c.name.toLowerCase()).includes(item)
        )
      );
    }
  };

  // Each filter category array for accessing
  const {
    includedCountries,
    includedRegions,
    includedDestinations,
    includedDepartureMonths,
    includedThemes,
    includedTourLeaders,
    includedArtists,
  } = filters;

  // Filtered result cards
  const filteredResults = results.filter((tour) => {
    return (
      matchingResults(includedCountries, "includedCountries", tour) &&
      matchingResults(includedRegions, "includedRegions", tour) &&
      matchingResults(includedDestinations, "includedCities", tour) &&
      matchingResults(includedTourLeaders, "includedTourLeaders", tour) &&
      matchingResults(
        includedDepartureMonths,
        "includedDepartureMonths",
        tour
      ) &&
      matchingResults(includedArtists, "includedArtists", tour) &&
      matchingResults(includedThemes, "includedThemes", tour)
    );
  });

  // Country - number of result cards on each country category and unique country options to show on filter
  const filteredCountries = results
    .filter((tourObj) => {
      const matchingRegions = matchingResults(
        includedRegions,
        "includedRegions",
        tourObj
      );

      const matchingDestinations = matchingResults(
        includedDestinations,
        "includedCities",
        tourObj
      );

      const matchingDepartureMonths = matchingResults(
        includedDepartureMonths,
        "includedDepartureMonths",
        tourObj
      );

      const matchingArtists = matchingResults(
        includedArtists,
        "includedArtists",
        tourObj
      );

      const matchingThemes = matchingResults(
        includedThemes,
        "includedThemes",
        tourObj
      );

      const matchingTourLeaders = matchingResults(
        includedTourLeaders,
        "includedTourLeaders",
        tourObj
      );

      return (
        matchingRegions &&
        matchingDestinations &&
        matchingDepartureMonths &&
        matchingArtists &&
        matchingThemes &&
        matchingTourLeaders
      );
    })
    .flatMap((tour) => tour.includedCountries.map((c) => c.name));
  const { counts: countryCounts } = getCounts(filteredCountries);
  const visibleCountries = [
    ...new Set(filteredCountries.filter((country) => country)),
  ].sort();

  // Region - number of result cards on each region category and unique region options to show on filter
  const filteredRegions = results
    .filter((tourObj) => {
      const matchingCountries = matchingResults(
        includedCountries,
        "includedCountries",
        tourObj
      );

      const matchingDestinations = matchingResults(
        includedDestinations,
        "includedCities",
        tourObj
      );

      const matchingDepartureMonths = matchingResults(
        includedDepartureMonths,
        "includedDepartureMonths",
        tourObj
      );

      const matchingArtists = matchingResults(
        includedArtists,
        "includedArtists",
        tourObj
      );

      const matchingThemes = matchingResults(
        includedThemes,
        "includedThemes",
        tourObj
      );

      const matchingTourLeaders = matchingResults(
        includedTourLeaders,
        "includedTourLeaders",
        tourObj
      );

      return (
        matchingCountries &&
        matchingDestinations &&
        matchingDepartureMonths &&
        matchingArtists &&
        matchingThemes &&
        matchingTourLeaders
      );
    })
    .flatMap((tour) => tour.includedRegions.map((r) => r.name));
  const { counts: regionCounts } = getCounts(filteredRegions);
  const visibleRegions = [
    ...new Set(filteredRegions.filter((region) => region)),
  ].sort();

  // Destinations or cities  - number of result cards on each destinations category and unique destination options to show on filter
  const filteredDestinations = results
    .filter((tourObj) => {
      const matchingCountries = matchingResults(
        includedCountries,
        "includedCountries",
        tourObj
      );

      const matchingDepartureMonths = matchingResults(
        includedDepartureMonths,
        "includedDepartureMonths",
        tourObj
      );

      const matchingRegions = matchingResults(
        includedRegions,
        "includedRegions",
        tourObj
      );

      const matchingArtists = matchingResults(
        includedArtists,
        "includedArtists",
        tourObj
      );

      const matchingThemes = matchingResults(
        includedThemes,
        "includedThemes",
        tourObj
      );

      const matchingTourLeaders = matchingResults(
        includedTourLeaders,
        "includedTourLeaders",
        tourObj
      );

      return (
        matchingCountries &&
        matchingRegions &&
        matchingDepartureMonths &&
        matchingThemes &&
        matchingArtists &&
        matchingTourLeaders
      );
    })
    .flatMap((tour) => tour.includedCities.map((r) => r.name));
  const { counts: destinationCounts } = getCounts(filteredDestinations);
  const visibleDestinations = [
    ...new Set(filteredDestinations.filter((destination) => destination)),
  ].sort();

  // Departure Months
  // Filtering departure months based on the other filter categories selected
  const filteredDepartureMonths = results
    .filter((tourObj) => {
      const matchingCountries = matchingResults(
        includedCountries,
        "includedCountries",
        tourObj
      );

      const matchingDestinations = matchingResults(
        includedDestinations,
        "includedCities",
        tourObj
      );

      const matchingRegions = matchingResults(
        includedRegions,
        "includedRegions",
        tourObj
      );

      const matchingArtists = matchingResults(
        includedArtists,
        "includedArtists",
        tourObj
      );

      const matchingThemes = matchingResults(
        includedThemes,
        "includedThemes",
        tourObj
      );

      const matchingTourLeaders = matchingResults(
        includedTourLeaders,
        "includedTourLeaders",
        tourObj
      );

      return (
        matchingCountries &&
        matchingRegions &&
        matchingDestinations &&
        matchingArtists &&
        matchingThemes &&
        matchingTourLeaders
      );
    })
    .flatMap((tour) => formatDates(tour) || []);

  const { counts: departureMonthCounts } = getCounts(filteredDepartureMonths);
  const visibleDepartureMonths = [
    ...new Set(
      filteredDepartureMonths
        .filter((date) => date)
        .sort(
          (a, b) =>
            dayjs(a, "MMMM YYYY").toDate() - dayjs(b, "MMMM YYYY").toDate()
        )
    ),
  ];

  // Themes - number of result cards on each themes category and unique themes options to show
  const filteredThemes = results
    .filter((tourObj) => {
      const matchingCountries = matchingResults(
        includedCountries,
        "includedCountries",
        tourObj
      );

      const matchingDestinations = matchingResults(
        includedDestinations,
        "includedCities",
        tourObj
      );

      const matchingDepartureMonths = matchingResults(
        includedDepartureMonths,
        "includedDepartureMonths",
        tourObj
      );

      const matchingRegions = matchingResults(
        includedRegions,
        "includedRegions",
        tourObj
      );

      const matchingArtists = matchingResults(
        includedArtists,
        "includedArtists",
        tourObj
      );

      const matchingTourLeaders = matchingResults(
        includedTourLeaders,
        "includedTourLeaders",
        tourObj
      );

      return (
        matchingCountries &&
        matchingRegions &&
        matchingDestinations &&
        matchingDepartureMonths &&
        matchingArtists &&
        matchingTourLeaders
      );
    })
    .flatMap(
      (tour) => tour.themeTags?.themeTags?.tag.map((t) => t.label) || []
    );
  const { counts: themesCounts } = getCounts(filteredThemes);
  const visibleThemes = [
    ...new Set(filteredThemes.filter((theme) => theme)),
  ].sort();

  // Reusable Utility function to get Tour Leaders and Artists to on Filter and the number of tours with each filter option
  const getVisibleItemsWithCounts = (items, array, itemKey) => {
    const resultsIds = array.map((el) => el._id);

    const counts = items.reduce((acc, item) => {
      if (
        Array.isArray(item.tours) &&
        item.tours.some((tour) => resultsIds.includes(tour._id))
      ) {
        // Count matching tours
        const matchCount = item.tours.filter((tour) =>
          resultsIds.includes(tour._id)
        ).length;

        // Increment the count for the item's title
        if (item[itemKey]) {
          acc[item[itemKey]] = (acc[item[itemKey]] || 0) + matchCount;
        }
      }
      return acc;
    }, {});

    const visibleItems = Object.keys(counts).sort();

    return { visibleItems, counts };
  };

  // Retrieving visible artist options for filter and the number of tours with each artist
  const filteredArtists = results.filter((tourObj) => {
    const matchingCountries = matchingResults(
      includedCountries,
      "includedCountries",
      tourObj
    );

    const matchingRegions = matchingResults(
      includedRegions,
      "includedRegions",
      tourObj
    );

    const matchingDestinations = matchingResults(
      includedDestinations,
      "includedCities",
      tourObj
    );

    const matchingTourLeaders = matchingResults(
      includedTourLeaders,
      "includedTourLeaders",
      tourObj
    );

    const matchingDepartureMonths = matchingResults(
      includedDepartureMonths,
      "includedDepartureMonths",
      tourObj
    );

    const matchingThemes = matchingResults(
      includedThemes,
      "includedThemes",
      tourObj
    );

    return (
      matchingCountries &&
      matchingRegions &&
      matchingDestinations &&
      matchingDepartureMonths &&
      matchingThemes &&
      matchingTourLeaders
    );
  });
  const { visibleItems: visibleArtists, counts: artistCounts } =
    getVisibleItemsWithCounts(artists, filteredArtists, "title");

  // Retrieving visible tour leaders options for filter and the number of tours with each leader
  const filteredTourLeaders = results.filter((tourObj) => {
    const matchingCountries = matchingResults(
      includedCountries,
      "includedCountries",
      tourObj
    );

    const matchingRegions = matchingResults(
      includedRegions,
      "includedRegions",
      tourObj
    );

    const matchingDestinations = matchingResults(
      includedDestinations,
      "includedCities",
      tourObj
    );

    const matchingArtists = matchingResults(
      includedArtists,
      "includedArtists",
      tourObj
    );

    const matchingDepartureMonths = matchingResults(
      includedDepartureMonths,
      "includedDepartureMonths",
      tourObj
    );

    const matchingThemes = matchingResults(
      includedThemes,
      "includedThemes",
      tourObj
    );

    return (
      matchingCountries &&
      matchingRegions &&
      matchingDestinations &&
      matchingDepartureMonths &&
      matchingThemes &&
      matchingArtists
    );
  });
  const { visibleItems: visibleTourLeaders, counts: leaderCounts } =
    getVisibleItemsWithCounts(tourLeaders, filteredTourLeaders, "title");

  // Filter Drop Down Options
  const filterDropdownConfig = [
    {
      label: "Countries",
      options: visibleCountries,
      counts: countryCounts,
      selectedOptions: filters.includedCountries,
      filterKey: "includedCountries",
    },
    {
      label: "Regions",
      options: visibleRegions,
      counts: regionCounts,
      selectedOptions: filters.includedRegions,
      filterKey: "includedRegions",
    },
    {
      label: "Destinations",
      options: visibleDestinations,
      counts: destinationCounts,
      selectedOptions: filters.includedDestinations,
      filterKey: "includedDestinations",
    },
    {
      label: "Tour Leaders",
      options: visibleTourLeaders,
      counts: leaderCounts,
      selectedOptions: filters.includedTourLeaders || [],
      filterKey: "includedTourLeaders",
    },
    {
      label: "Artists",
      options: visibleArtists,
      counts: artistCounts,
      selectedOptions: filters.includedArtists,
      filterKey: "includedArtists",
    },
    {
      label: "Departure Months",
      options: visibleDepartureMonths,
      counts: departureMonthCounts,
      selectedOptions: filters.includedDepartureMonths,
      filterKey: "includedDepartureMonths",
    },
    {
      label: "Themes",
      options: visibleThemes,
      counts: themesCounts,
      selectedOptions: filters.includedThemes,
      filterKey: "includedThemes",
    },
  ];

  // Sorting result cards by date for Tour Calendar archive
  if (
    sortType === "date" &&
    culturalTourArchivePageResults.length > 0 &&
    !sortBy
  ) {
    culturalTourArchivePageResults.sort((a, b) => {
      const dateA = a?.minDate?.landonlydeparturedate;
      const dateB = b?.minDate?.landonlydeparturedate;
      if (dateA === undefined) return 1;
      if (dateB === undefined) return -1;
      const dateObjA = new Date(dateA);
      const dateObjB = new Date(dateB);
      if (isNaN(dateObjA)) return 1;
      if (isNaN(dateObjB)) return -1;
      return dateObjA - dateObjB;
    });
  } else if (!sortBy) {
    culturalTourArchivePageResults.sort((a, b) =>
      a.offerPrice?.localeCompare(b.offerPrice)
    );
  }

  // Pagination
  const resultsPerPage = 15;
  const totalPages = Math.ceil(filteredResults.length / resultsPerPage);
  const currentResults = culturalTourArchivePageResults.slice(
    currentPage * resultsPerPage,
    currentPage * resultsPerPage + resultsPerPage
  );

  // Sorting results based on value chosen
  useEffect(() => {
    if (sortBy === "Title (A-Z)") {
      const sortedResults = [...filteredResults].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      setCulturalTourArchivePageResults(sortedResults);
    } else if (sortBy === "Title (Z-A)") {
      const sortedResults = [...filteredResults].sort((a, b) =>
        b.title.localeCompare(a.title)
      );
      setCulturalTourArchivePageResults(sortedResults);
    } else {
      setCulturalTourArchivePageResults(filteredResults);
    }
  }, [sortBy, filteredResults.length]);

  const [toggleMobileFilters, setToggleMobileFilters] = useState(false);

  return (
    <ArchivePageStyling className="archive-page">
      {!page?.hero?.heroTitle && (
        <div className="section-title">
          <h2 className="red">{page.name}</h2>
        </div>
      )}
      <div className="search-wrapper">
        <div className="sidebar">
          <div className="sidebar-heading">
            <h5 className="sidebar-heading-title">Filters</h5>
            <p
              className="clear-all-btn"
              role="button"
              onClick={resetAllFilters}
            >
              Clear all
            </p>
          </div>
          <p className="small">{`Showing ${filteredResults.length} of ${results.length}`}</p>

          {filterDropdownConfig && filterDropdownConfig.length > 0 && (
            <div className="accordion">
              {filterDropdownConfig.map(
                ({ label, options, counts, selectedOptions, filterKey }) => (
                  <FilterDropdown
                    key={filterKey}
                    label={label}
                    options={options}
                    counts={counts}
                    selectedOptions={selectedOptions}
                    onChange={(value) => handleCheckboxChange(filterKey, value)}
                  />
                )
              )}
            </div>
          )}
        </div>

        <div className="mobile-filters">
          <Button
            size="xl"
            btnStyle="outline"
            className=""
            value={"Filters"}
            clickHandler={() => setToggleMobileFilters(!toggleMobileFilters)}
          >
            Filters
          </Button>
        </div>
        {toggleMobileFilters && (
          <div className="mobile-filers-wrapper">
            <div
              className="close-filters"
              onClick={() => setToggleMobileFilters(false)}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_9157_142338)">
                  <path
                    d="M23.7695 10.207L17.6758 16.3008L23.7188 22.3438C24.2266 22.8008 24.2266 23.5625 23.7188 24.0195C23.2617 24.5273 22.5 24.5273 22.043 24.0195L15.9492 17.9766L9.90625 24.0195C9.44922 24.5273 8.6875 24.5273 8.23047 24.0195C7.72266 23.5625 7.72266 22.8008 8.23047 22.293L14.2734 16.25L8.23047 10.207C7.72266 9.75 7.72266 8.98828 8.23047 8.48047C8.6875 8.02344 9.44922 8.02344 9.95703 8.48047L16 14.5742L22.043 8.53125C22.5 8.02344 23.2617 8.02344 23.7695 8.53125C24.2266 8.98828 24.2266 9.75 23.7695 10.207Z"
                    fill="#333333"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_9157_142338">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="heading">FILTERS</div>
            <p className="small">{`Showing ${filteredResults.length} of ${results.length}`}</p>
            <div className="dropdowns-wrapper">
              {filterDropdownConfig && filterDropdownConfig.length > 0 && (
                <div className="accordion">
                  {filterDropdownConfig.map(
                    ({
                      label,
                      options,
                      counts,
                      selectedOptions,
                      filterKey,
                    }) => (
                      <FilterDropdown
                        key={filterKey}
                        label={label}
                        options={options}
                        counts={counts}
                        selectedOptions={selectedOptions}
                        onChange={(value) =>
                          handleCheckboxChange(filterKey, value)
                        }
                      />
                    )
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="results-wrapper">
          <div className="result-wrapper-header">
            <div className="current-search-tags">
              {tags.map((tag, index) => (
                <Tag tag={tag} index={index} removeTag={removeTag} />
              ))}
            </div>
            <SortByDropdown selected={sortBy} sortByHandler={sortByHandler} />
          </div>
          <Separator color="red" />
          <div className="results">
            {currentResults.length > 0 ? (
              currentResults.map((card, index) => (
                <TourCard
                  key={card._id}
                  card={card}
                  index={index}
                  page={page}
                  filters={filters}
                />
              ))
            ) : (
              <div className="card-wrapper">
                <h6>No results match</h6>
                <Separator color="red" />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Pagination */}
      {totalPages > 1 && (
        <FilterPagination
          nPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </ArchivePageStyling>
  );
};

export default CulturalTourContent;
